// extracted by mini-css-extract-plugin
export default {"divider":"AJF5YqDC8JCzvUQiFQiL","empty":"ZsLCE7CHJZlDjLClVyTO"};